// import { REDIRECT_URL } from '../../constants/global.constants';

import safelyParseJSON from '../../utils/safelyParseJson';
import { zenworksServiceApi } from '../../service/zenworksService.api';
import getSwitchExchangeToken from '../../utils/getSwitchExchangeToken';
import { postToParent } from '../../utils/postMessage';

export const TOGGLE_CHAT_SCREEN = 'TOGGLE_CHAT_SCREEN';
export const CLOSE_CHAT_SCREEN = 'CLOSE_CHAT_SCREEN';
export const OPEN_CHAT_SCREEN = 'OPEN_CHAT_SCREEN';

const REDIRECT_URL = '*';
type ChatScreenActionType =
  | typeof TOGGLE_CHAT_SCREEN
  | typeof OPEN_CHAT_SCREEN
  | typeof CLOSE_CHAT_SCREEN;

type ChatScreenStateType = {
  isChatOpen: boolean;
  isChatInitiatedByUser: boolean;
};

const isChatOpenKey = 'is-chat-open';
const isChatInitiatedByUserKey = 'is-chat-initiated-by-user';
const getInitialChatOpen = () =>
  !!safelyParseJSON(localStorage.getItem(isChatOpenKey) as string);

function saveToLocalStorage(
  isChatOpen: boolean,
  isChatInitiatedByUser?: boolean,
) {
  localStorage.setItem(isChatOpenKey, JSON.stringify(isChatOpen));
  localStorage.setItem(
    isChatInitiatedByUserKey,
    JSON.stringify(isChatInitiatedByUser),
  );
}

const getInitialChatByUserOpen = () => {
  return !!safelyParseJSON(
    localStorage.getItem(isChatInitiatedByUserKey) as string,
  );
};

const getAuthFromLocal = () =>
  safelyParseJSON(localStorage.getItem('auth') as string);

async function webLogin() {
  const authDetails = getAuthFromLocal();
  if (!(authDetails && authDetails.auth)) return;
  try {
    // await indexedDBService.deleteEvent(key);
    const response = await zenworksServiceApi.produceToken();
    const switch_exchange_token = getSwitchExchangeToken(response.content);
    const results = await zenworksServiceApi.loginWithExchangeToken({
      switch_exchange_token,
    });
    console.log({ results })
  } catch (error) {
    console.error('Error during web login:', error);
  }
}


const initialState: ChatScreenStateType = {
  isChatOpen: getInitialChatOpen(),
  isChatInitiatedByUser: getInitialChatByUserOpen() ?? false,
};

const chatScreenReducer = (
  state = initialState,
  action: { type: ChatScreenActionType },
): ChatScreenStateType => {
  switch (action.type) {
    case TOGGLE_CHAT_SCREEN: {
      const newIsChatOpen = !state.isChatOpen;
      const tempChatInitiatedValue = true;
      saveToLocalStorage(newIsChatOpen, tempChatInitiatedValue);
      const dataToSend = {
        isChatOpen: newIsChatOpen,
        isChatInitiatedByUser: state.isChatInitiatedByUser,
      };
      window.parent.postMessage(dataToSend, REDIRECT_URL);
      postToParent(newIsChatOpen ? 'OPEN_CHAT_WINDOW' : 'CLOSE_CHAT_WINDOW', {});
      webLogin();

      return {
        ...state,
        isChatOpen: newIsChatOpen,
        isChatInitiatedByUser: tempChatInitiatedValue,
      };
    }
    case CLOSE_CHAT_SCREEN: {
      const newIsChatOpen = false;
      saveToLocalStorage(newIsChatOpen);
      const dataToSend = {
        isChatOpen: newIsChatOpen,
        isChatInitiatedByUser: state.isChatInitiatedByUser,
      };
      window.parent.postMessage(dataToSend, REDIRECT_URL);
      postToParent('CLOSE_CHAT_WINDOW', {});
      return { ...state, isChatOpen: newIsChatOpen };
    }
    case OPEN_CHAT_SCREEN: {
      const newIsChatOpen = true;
      saveToLocalStorage(newIsChatOpen);
      const dataToSend = {
        isChatOpen: newIsChatOpen,
        isChatInitiatedByUser: state.isChatInitiatedByUser,
      };
      window.parent.postMessage(dataToSend, REDIRECT_URL);
      postToParent('OPEN_CHAT_WINDOW', {});
      return { ...state };
    }
    default: {
      const isChatOpenFromLocal = getInitialChatOpen();
      const isChatInitiatedByUserLocal = getInitialChatByUserOpen() ?? false;
      window.parent.postMessage(
        {
          ...state,
          isChatOpen: isChatOpenFromLocal,
          isChatInitiatedByUser: isChatInitiatedByUserLocal,
        },
        REDIRECT_URL,
      );
      return { ...state };
    }
  }
};

export default chatScreenReducer;
